import React from 'react'
import { SettingTab } from '@/components/molecules/settings/setting-tab'
import { listContainerStyle } from '@/constants/layout'
import { css } from '@emotion/core'

export const SurveyTab: React.FC<{ currentTab: 'Item' | 'Google Map' }> = ({ currentTab, children }) => {
  const getTabs = () => {
    return [
      {
        name: 'Item',
        path: '/setting/survey',
      },
      {
        name: 'Google Map',
        path: '/setting/survey/google-map',
      },
    ]
  }

  return (
    <SettingTab currentTab={currentTab} tabs={getTabs()} customTabStyle={css({ width: 160 })}>
      <div css={topImageContainerStyle}>{children}</div>
    </SettingTab>
  )
}

const topImageContainerStyle = css(listContainerStyle, {
  width: '100%',
  background: '#FFF',
  minHeight: 'auto',
  marginBottom: -10,
})
